















































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateBankAccountModalViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-bank-account/update-bank-account-modal-view-model';

@Component({
  name: 'UpdateBankAccountModal',
  components: {
    UpdateBankAccountChooseYourDocuments: () => import('./UpdateBankAccountChooseYourDocuments.vue'),
    UpdateBankAccountData: () => import('./UpdateBankAccountData.vue'),
  },
})
export default class UpdateBankAccountModal extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  update_bank_account_view_model = Vue.observable(new UpdateBankAccountModalViewModel(this));

  closeModal() {
    this.synced_is_open = false;
  }

  endProcess(document_was_wealth: boolean) {
    this.update_bank_account_view_model.clearState();
    this.$emit('openUpdatedBankAccountSuccessModal', document_was_wealth);
    this.closeModal();
  }
}
